var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 102,
    viewBox: "0 0 94 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.2019 5.84522C28.2668 5.84522 29.13 4.98443 29.13 3.92261C29.13 2.86078 28.2668 2 27.2019 2C26.1371 2 25.2739 2.86078 25.2739 3.92261C25.2739 4.98443 26.1371 5.84522 27.2019 5.84522Z",
    fill: "url(#paint0_linear_766_2676)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82 57C83.1046 57 84 56.1046 84 55C84 53.8954 83.1046 53 82 53C80.8954 53 80 53.8954 80 55C80 56.1046 80.8954 57 82 57Z",
    fill: "#F784AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2759 17.6396C71.8016 17.6396 68.6422 16.3797 67.589 15.9597C61.9021 13.4399 52.424 5.88037 47.369 5.88037C42.3139 5.88037 32.8358 13.4399 27.1489 15.9597C26.0957 16.3797 22.9364 17.6396 21.462 17.6396C19.3557 17.6396 17.6707 19.5295 17.8813 21.8394C18.5132 26.879 19.777 35.9085 23.3576 47.4578C27.7807 61.7369 40.6289 70.3463 45.4733 73.0761C46.7371 73.7061 48.2115 73.7061 49.2646 73.0761C54.109 70.3463 66.9572 61.7369 71.3803 47.4578C74.9609 35.9085 76.4353 26.879 76.8566 21.8394C77.0672 19.5295 75.3822 17.6396 73.2759 17.6396Z",
    fill: "#E6EDF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_766_2676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5926 22.4692C71.1713 26.4589 70.1182 32.7585 67.8013 40.738C67.5907 41.158 67.5907 41.578 67.3801 42.2079C67.1694 43.2579 66.7482 44.5178 66.3269 45.5677C64.2207 52.4973 59.7975 57.9569 55.3744 61.9467C52.4256 64.6765 49.2662 66.7764 47.3706 68.0363C46.9493 67.8263 46.3175 67.4063 45.6856 66.9864C40.4199 63.4166 31.5737 56.277 28.4143 45.7777C25.2549 35.4883 23.7805 27.2989 23.3593 22.6792C25.8868 22.2592 28.8355 20.9993 29.4674 20.7893C31.7843 19.7393 34.3118 18.0594 37.0499 16.3796C39.9987 14.4897 45.6856 11.1299 47.5812 11.1299C49.4769 11.1299 55.1638 14.6997 58.1125 16.3796C60.8506 18.0594 63.3782 19.7393 65.695 20.7893C66.1163 20.7893 69.0651 22.0492 71.5926 22.4692Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M67.8016 40.7384C67.591 41.1584 67.591 41.5783 67.3803 42.2083C67.1697 43.2582 66.7485 44.5182 66.3272 45.5681C64.2209 52.4977 59.7978 57.9573 55.3747 61.9471L40.2096 46.828L41.2627 38.8485L50.109 34.4388L44.6327 34.8588L43.1584 25.6193L50.9515 23.9395L67.8016 40.7384Z",
    fill: "#E1EAF2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4255 32.3387V27.509C52.4255 25.1991 50.5299 22.8893 48.4236 22.4693C46.7386 22.2593 45.0536 22.6793 44.0005 23.9392C43.158 24.7791 42.5261 26.0391 42.5261 27.509V32.5487C41.2623 33.3886 39.9986 34.6485 39.1561 35.9084C38.3136 37.1684 37.8923 38.6383 37.8923 40.3182C37.6817 45.5678 41.8942 49.9776 47.1599 50.1875C52.6361 50.3975 57.0593 45.9878 57.0593 40.7381C57.0593 37.1684 55.1637 34.0186 52.4255 32.3387ZM48.6342 41.5781V44.0979C48.6342 44.5179 48.4236 44.7279 48.0024 44.7279H46.9493C46.528 44.7279 46.3174 44.5179 46.3174 44.0979V42.418V41.3681C45.2642 41.1581 44.843 40.1082 45.0536 39.0582C45.2642 38.2183 45.8961 37.3783 46.9493 37.1684C48.4236 36.7484 49.898 38.0083 49.898 39.4782C49.6874 40.3182 49.2661 41.1581 48.6342 41.5781ZM50.3193 31.4987C49.4768 31.2887 48.4236 31.0788 47.3705 31.0788C46.528 31.0788 45.4749 31.2887 44.6324 31.4987V27.719C44.6324 26.879 45.0536 26.2491 45.4749 25.8291C46.1067 25.1991 47.3705 24.7791 48.6342 25.1991C49.6874 25.6191 50.3193 26.669 50.3193 27.9289V31.4987Z",
    fill: "url(#paint1_linear_766_2676)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77633 84.6291L9.87911 81.7363L7.41926 80.2095L5.67355 83.5443L3.92784 80.2095L1.46798 81.7363L3.61044 84.6291L0 84.388V87.2809L3.61044 87.0398L1.46798 89.9327L3.92784 91.4595L5.67355 88.1247L7.41926 91.4595L9.87911 89.9327L7.77633 87.0398L11.3471 87.2809V84.388L7.77633 84.6291Z",
    fill: "url(#paint2_linear_766_2676)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5069 84.6291L25.6097 81.7363L23.1498 80.2095L21.4041 83.5443L19.6584 80.2095L17.1986 81.7363L19.341 84.6291L15.7306 84.388V87.2809L19.341 87.0398L17.1986 89.9327L19.6584 91.4595L21.4041 88.1247L23.1498 91.4595L25.6097 89.9327L23.5069 87.0398L27.0777 87.2809V84.388L23.5069 84.6291Z",
    fill: "url(#paint3_linear_766_2676)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2375 84.6291L41.3403 81.7363L38.8804 80.2095L37.1347 83.5443L35.389 80.2095L32.9291 81.7363L35.0716 84.6291L31.4612 84.388V87.2809L35.0716 87.0398L32.9291 89.9327L35.389 91.4595L37.1347 88.1247L38.8804 91.4595L41.3403 89.9327L39.2375 87.0398L42.8083 87.2809V84.388L39.2375 84.6291Z",
    fill: "url(#paint4_linear_766_2676)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9681 84.6291L57.0709 81.7363L54.611 80.2095L52.8653 83.5443L51.1196 80.2095L48.6597 81.7363L50.8022 84.6291L47.1917 84.388V87.2809L50.8022 87.0398L48.6597 89.9327L51.1196 91.4595L52.8653 88.1247L54.611 91.4595L57.0709 89.9327L54.9681 87.0398L58.5388 87.2809V84.388L54.9681 84.6291Z",
    fill: "url(#paint5_linear_766_2676)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6987 84.6291L72.8014 81.7363L70.3416 80.2095L68.5959 83.5443L66.8502 80.2095L64.3903 81.7363L66.5328 84.6291L62.9223 84.388V87.2809L66.5328 87.0398L64.3903 89.9327L66.8502 91.4595L68.5959 88.1247L70.3416 91.4595L72.8014 89.9327L70.6987 87.0398L74.2694 87.2809V84.388L70.6987 84.6291Z",
    fill: "url(#paint6_linear_766_2676)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4292 84.6291L88.532 81.7363L86.0722 80.2095L84.3264 83.5443L82.5807 80.2095L80.1209 81.7363L82.2633 84.6291L78.6529 84.388V87.2809L82.2633 87.0398L80.1209 89.9327L82.5807 91.4595L84.3264 88.1247L86.0722 91.4595L88.532 89.9327L86.4292 87.0398L90 87.2809V84.388L86.4292 84.6291Z",
    fill: "url(#paint7_linear_766_2676)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_766_2676",
    x: 1.35925,
    y: 0.129883,
    width: 92.2333,
    height: 100.906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_766_2676"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_766_2676",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_766_2676",
    x1: 29.994,
    y1: 3.3218,
    x2: 24.9526,
    y2: 3.3218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B74F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D4289"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_766_2676",
    x1: 61.3558,
    y1: 31.9661,
    x2: 36.2869,
    y2: 31.9661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B74F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D4289"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_766_2676",
    x1: 110.167,
    y1: 84.0767,
    x2: -7.5,
    y2: 84.0767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B74F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D4289"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_766_2676",
    x1: 110.167,
    y1: 84.0767,
    x2: -7.5,
    y2: 84.0767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B74F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D4289"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_766_2676",
    x1: 110.167,
    y1: 84.0767,
    x2: -7.5,
    y2: 84.0767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B74F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D4289"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_766_2676",
    x1: 110.167,
    y1: 84.0767,
    x2: -7.5,
    y2: 84.0767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B74F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D4289"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_766_2676",
    x1: 110.167,
    y1: 84.0767,
    x2: -7.5,
    y2: 84.0767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B74F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D4289"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_766_2676",
    x1: 110.167,
    y1: 84.0767,
    x2: -7.5,
    y2: 84.0767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B74F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D4289"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.7fef252805bf2d5ef60aff4b962a7e07.svg";
export { ForwardRef as ReactComponent };